<template lang="html">
  <div>
    <div class="content-i">
      <div class="content-box" style="padding-bottom: 0px;">
        <div class="element-wrapper" style="padding-bottom: 0px;">
          <h6 class="element-header">{{ t('titleAddCustomers','titleAddCustomers') }}</h6>
          <div class="element-box">
            <div class="element-info">
              <div class="row align-items-center">
                <div class="col-sm-8">
                  <div class="element-info-with-icon">
                    <div class="element-info-icon">
                      <fontAwesomeIcon :icon="['fa', 'user-edit']" size="1x" class=""/>
                    </div>
                    <div class="element-info-text">
                      <h5 class="element-inner-header">{{ t('titleAddCustomer','titleAddCustomer') }}</h5>
                      <div class="element-inner-desc">{{ t('addNewCustomerRefToYourAccount', 'addNewCustomerRefToYourAccount') }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div>
              <form v-on:submit.prevent="addCustomer">
                <h6 class="element-header" >{{t('descAddCustomerToUser','descAddCustomerToUser')}}</h6>
                <div class="col-12 row mb-5" >
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <b-col sm="6">
                      <label for="custRef"><span class="text-danger">*</span>{{ t('enterCustomerRef', 'enterCustomerRef')}}</label>
                    </b-col>
                    <b-form-input id="custRef" v-model="customersData.reference" :placeholder="t('enterCustomerRef', 'enterCustomerRef')"></b-form-input>
                  </div>
                  <div class="col-sm-12 col-md-6 col-lg-4">
                    <b-col sm="6">
                      <label for="custPass"><span class="text-danger">*</span>{{ t('enterCustomerPass', 'enterCustomerPass')}}</label>
                    </b-col>
                    <b-form-input id="custPass" :type="'password'" v-model="customersData.password" :placeholder="t('enterPassword', 'enterPassword')"></b-form-input>
                  </div>
                </div>

                <transition name="fade">
                  <ResponseInfo v-if="getResponseInfo.responseName == 'addCustomer'" class="mt-3"/>
                </transition>

                <b-alert
                  :show="(getResponseInfo.status == 'info') && (getResponseInfo.responseName == 'addCustomer')"
                  variant="info"
                  dismissible
                  fade
                  @dismissed="clearResponse()"
                >
                  <p>
                    {{t('descAlreadyRegisteredInitialPassChanged','descAlreadyRegisteredInitialPassChanged')}}
                    <!--<button class="btn btn-secondary" type="button">{{getResponseInfo.responseData}}</button>-->
                    {{getResponseInfo.responseData}}
                  </p>

                  <p>{{t('descAlreadyRegisteredAlreadyLoggedInChangedPass','descAlreadyRegisteredAlreadyLoggedInChangedPass')}}</p>
                  <p>{{t('descAlreadyRegisteredPleaseContactForNewPass','descAlreadyRegisteredPleaseContactForNewPass')}}</p>
                </b-alert>

                <div class="col-12 d-flex justify-content-end">
                  <button v-if="!isBusy" class="btn btn-primary" type="submit" :disabled="formFilled">{{ t('buttonUpdate','buttonUpdate') }}</button>
                  <b-button v-else variant="primary" disabled>
                    <b-spinner small type="grow"></b-spinner>
                    {{ t('searchCustomersBtn','searchCustomersBtn') }}
                  </b-button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import ResponseInfo from '@/components/ResponseInfo.vue'

    export default {
    name: 'add_customer',
    data() {
      return {
        customersData: {},
        isBusy: false
      }
    },
    computed:{
        ...mapGetters(['getResponseInfo']),
        formFilled() {
          if(!this.customersData.reference || !this.customersData.password) {
            return true
          } else {
            return false
          }
        }
    },
    methods: {
      addCustomer() {
        // NS-10669 Clear response every time we call this function, it needed a small timeout so the change could be noticed PW
        this.clearResponse()
        this.isBusy = true

        setTimeout(() => { 
          this.$store.dispatch('customerStore/addCustomer', this.customersData)
          .then(() => {
            this.isBusy = false
          })
          }, 500
        );

      },
      clearResponse() {
        this.$store.dispatch('alertClearResponse')
      }
    },
    created() {
    },
    components: {
      ResponseInfo
    }
}
</script>

<style lang="css" scoped>
#delimiters {
  padding: 0;
}
</style>
